import {
    APIAppInstanceModel,
    AppInstanceListParams,
    APIAppInstanceMetaModel
} from "../Models/API/AppInstanceModel"
import { useAppState } from "./useReduxState"
import { FetchState } from "../Models/Client/FetchState"
import { getItemList, getPageToFetch } from "../Models/Client/RemoteData"
import { Result } from "../Models/Utility/Result"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { getInstanceList } from "../Actions/API/AppInstance/AppInstanceActions"

export function useAppInstanceList(
    orgUsername: string,
    params: AppInstanceListParams
): FetchState<{
    items: APIAppInstanceModel[]
    total: number
    totalArchived: number
}> {
    const dispatch = useDispatch()
    const entry = useAppState(state => state.api.apps.apps)

    useEffect(() => {
        const page = getPageToFetch(entry, params)

        if (page >= 0) {
            dispatch(getInstanceList(orgUsername, params, page))
        }
    }, [dispatch, params, entry, orgUsername])

    return useMemo(() => {
        if (
            entry === undefined ||
            entry.list === undefined ||
            JSON.stringify(entry.list.params) !== JSON.stringify(params)
        ) {
            return undefined
        }

        return Result.ok({
            items: getItemList(entry),
            total: entry.list.total,
            totalArchived: (entry.list.meta as APIAppInstanceMetaModel)
                ?.totalArchived
        })
    }, [entry, params])
}
